function initializeNewsletterPopup() {
  // Update settings from the element
  var popupElement = document.querySelector('.newsletter-popup');
  var newsletterEnabled = newsletterPopupSettings.newsletterEnabled;
  var delay = newsletterPopupSettings.delay;
  var frequency = newsletterPopupSettings.frequency;
  var showOnHomepageOnly = newsletterPopupSettings.showOnHomepageOnly;
  var popup = document.querySelector('.newsletter-popup');
  var closeButton = document.querySelector('.newsletter-popup-close-btn');

  newsletterPopupSettings.testMode = popupElement.getAttribute('data-test-mode');
  var testMode = newsletterPopupSettings.testMode;

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
  function shouldShowPopup() {
    if (testMode === 'true') {
      return true;
    }
    
    var lastShown = getCookie('newsletterPopupShown');
    var now = new Date().getTime();

    if (!lastShown) {
      return true;
    }
    
    if (frequency === 0) {
      return true; // Always show the popup if frequency is set to 0
    }
    
    var daysSinceLastShown = (now - lastShown) / (1000 * 60 * 60 * 24);
    return daysSinceLastShown >= frequency;
  }

  function showPopup() {
    popup.style.display = 'flex';

    var popupWrapper = document.querySelector('.newsletter-popup-wrapper');
    if (popupWrapper) {
      popupWrapper.style.display = 'flex'; // Show the wrapper
    }
  }

  var urlParams = new URLSearchParams(window.location.search);
  var formSubmitted = urlParams.get('customer_posted') === 'true';
  var captchaChallenge = window.location.href.includes('challenge#contact_form');

  if (captchaChallenge) {
    return; // Exit the function early if it's the captcha page
  }

  function closePopup() {
    popup.style.display = 'none';

    var popupWrapper = document.querySelector('.newsletter-popup-wrapper');

    if (popupWrapper) {
      popupWrapper.style.display = 'none'; // Hide the wrapper
    }

    setCookie('newsletterPopupShown', 'true', frequency);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  var popup = document.querySelector('.newsletter-popup');
  var popupWrapper = document.querySelector('.newsletter-popup-wrapper');

  if (popupWrapper) {
    popupWrapper.addEventListener('click', function() {
      closePopup();
    });
  }

  if (popup) {
    popup.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent clicks inside the popup from propagating
    });
  }

  if (formSubmitted) {
    showPopup(); // Show immediately if form was submitted
  } else {
      
    if (testMode === 'true') {
      showPopup();
    } else if (newsletterEnabled === true && shouldShowPopup() && !(Shopify && Shopify.designMode)) {
    
      if (!showOnHomepageOnly || (showOnHomepageOnly && window.location.pathname === '/')) {
        setTimeout(showPopup, delay * 1000);
      }
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", initializeNewsletterPopup);

// Reinitialize on Shopify's theme editor events
document.addEventListener('shopify:section:load', initializeNewsletterPopup);
document.addEventListener('shopify:section:unload', initializeNewsletterPopup);
document.addEventListener('shopify:block:select', initializeNewsletterPopup);
document.addEventListener('shopify:block:deselect', initializeNewsletterPopup);